import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InfoOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"info_outline"}/>
}
